<template>
  <div class="popup_wrap">
    <span @click="openDetailModal">
      <slot />
    </span>
    <!-- 레이어팝업 -->
    <modal @close="closeModal" :open="modal.open" title="예약변경">
      <h5 class="stitle2 mb10">예약변경</h5>

      <div class="tb_wrap mb10">
        <table class="tb_basic">
          <caption>예약변경 리스트</caption>
          <colgroup>
            <col width="120" />
            <col />
            <col width="120" />
            <col />
          </colgroup>
          <tbody>
            <tr>
              <th>예약번호</th>
              <td>{{ rvDetail.bundleRvNo }}</td>
              <th>예약상태</th>
              <td>{{ rvDetail.rvProgSituNm }}</td>
            </tr>
            <tr>
              <th>체험일</th>
              <td>{{ rvDetail.expVisitRvdtF }}</td>
              <th>상품</th>
              <td>{{ rvDetail.pdNm }}</td>
            </tr>
            <tr>
              <th>회차</th>
              <td colspan="3">
                <select v-model="rvDetail.scheSeqNo">
                  <option v-for="sche in scheSeqNoList" :key="sche.mrktnScheSeqNo" :value="sche.mrktnScheSeqNo">
                    {{ sche.mrktnScheSeqNm }}({{ sche.tm }})&nbsp;{{ sche.rvResiduePcnt }}석
                  </option>
                </select>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <ul class="colorBox tcolor2 mb20">
        <li>* 팝업화면에서 예약 변경 후 변경화면 하단 예약변경 적용(저장)버튼까지 클릭하셔야 최종 변경됩니다.</li>
        <li>* 회차를 변경하실 경우 기존에 선택된 체험실이 삭제됩니다.</li>
        <li v-if="rvDetail.groupPersDiv === '02'">* 추가 인원 예약이 필요하신 경우 신규 예약을 진행해 주세요.</li>
      </ul>
      <template v-if="rvDetail.groupPersDiv === '01'">
        <h5 class="stitle2 mb20">체험자 인원 - {{ rvPesn20Pcnt }}명</h5>
        <div class="tb_wrap mb10">
          <table class="tb_basic">
            <caption>체험자 인원</caption>
            <colgroup>
              <col width="140" />
              <col />
              <col />
              <col width="200" />
            </colgroup>
            <thead>
              <tr class="tbg">
                <th scope="col">구분</th>
                <th scope="col">할인내용</th>
                <th scope="col">할인율</th>
                <th scope="col">신청인원</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(rvPesn, i) in rvPesn20List" :key="rvPesn.reciDivCd + rvPesn.pesnDivCd + rvPesn.pdNo">
                <td v-if="i === 0" :rowspan="rvPesn20List.length">{{ rvPesn.reciDivNm }}</td>
                <td>{{ rvPesn.note }}</td>
                <td>{{ rvPesn.discRateView }}</td>
                <td>
                  <count-button title="인원" :value="rvPesn.pcnt" :min="0" :onChange="(pcnt) => onChangeExperPcnt(rvPesn, pcnt)" :target="rvPesn" />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <template v-if="leaderInfoList.length > 0">
          <h5 class="stitle2 mb10">
            인솔자 목록 - {{ leaderList.length }}명
            <div class="tit_btnbox"><a class="btn_color" @click="onAddLeader">추가</a></div>
          </h5>
          <div class="tb_wrap mb30">
            <table class="tb_basic">
              <caption>인솔자목록 리스트</caption>
              <colgroup>
                <col width="10%" />
                <col width="20%" />
                <col />
                <col />
                <col width="20%" />
                <col width="80px" />
              </colgroup>
              <thead>
                <tr class="tbg">
                  <th scope="col">번호</th>
                  <th scope="col">인솔자명</th>
                  <th scope="col">휴대폰</th>
                  <th scope="col">E-mail</th>
                  <th scope="col">복지할인</th>
                  <th scope="col">삭제</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(leader, i) in leaderList" :key="leader.leaderId" :class="{ editable: leader.isAdded }">
                  <td>{{ i + 1 }}</td>
                  <template v-if="leader.isAdded">
                    <td><input type="text" v-model="leader.leaderNm" maxlength="10" /></td>
                    <td><input type="text" v-model="leader.phoneNo" maxlength="15" /></td>
                    <td><input type="text" v-model="leader.email" maxlength="20" /></td>
                    <td>
                      <select v-model="leader.pesnDivCd">
                        <option v-for="pesn in rvPesn10List" :key="pesn.pesnDivCd" :value="pesn.pesnDivCd">
                          {{ pesn.pesnDivNm }}
                        </option>
                      </select>
                    </td>
                  </template>
                  <template v-else>
                    <td>{{ leader.leaderNm }}</td>
                    <td>{{ leader.phoneNo }}</td>
                    <td>{{ leader.email }}</td>
                    <td>{{ leader.pesnDivNm }}</td>
                  </template>
                  <td><button @click="() => onDeleteLeader(leader)">삭제</button></td>
                </tr>
              </tbody>
            </table>
          </div>
        </template>
      </template>
      <template v-else>
        <template v-if="experInfoList.length > 0">
          <template v-if="rvDetail.pdDiv === '02' || rvDetail.pdDiv === '10'">
            <h5 class="stitle2 mb10">
              체험실 선택
              <!-- <div v-if="editExhpAble" class="tit_btnbox"><a class="btn_color" @click="toggleEdit">수정</a></div> -->
            </h5>
            <div class="tb_wrap mb20">
              <table class="tb_basic">
                <caption></caption>
                <colgroup>
                  <col width="60px" />
                  <col width="100px" />
                  <col />
                  <col />
                  <col width="60px" />
                  <col width="60px" />
                  <col />
                  <col />
                  <col />
                  <!-- <col width="20%" /> -->
                  <col width="70px" />
                </colgroup>
                <thead>
                  <tr class="tbg">
                    <th scope="col">번호</th>
                    <th scope="col">체험자명</th>
                    <th scope="col">ID</th>
                    <th scope="col">학년</th>
                    <th scope="col">반</th>
                    <th scope="col">번호</th>
                    <th scope="col">생년월일</th>
                    <th scope="col">Email</th>
                    <th scope="col">체험실</th>
                    <!-- <th scope="col">복지할인</th> -->
                    <th scope="col">삭제</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(exper, i) in experList" :key="exper.incluId">
                    <td>{{ i + 1 }}</td>
                    <td>{{ exper.incluNm }}</td>
                    <td>{{ exper.incluUserId }}</td>
                    <td>{{ exper.gradeNm }}</td>
                    <td>{{ exper.incluClass }}</td>
                    <td>{{ exper.incluClsNo }}</td>
                    <td>{{ exper.incluBirthMonDate }}</td>
                    <td>{{ exper.email }}</td>
                    <td>{{ exper.exhpHallNm }}</td>
                    <!-- <td>{{ exper.pesnDivNm }}</td> -->
                    <td><button @click="() => onDeleteExper(exper)">삭제</button></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </template>
          <template v-else>
            <h5 class="stitle2 mb10">체험자 목록</h5>
            <div class="tb_wrap mb20">
              <table class="tb_basic" id="childInfoT">
                <caption></caption>
                <colgroup>
                  <col width="10%" />
                  <col width="20%" />
                  <col />
                  <col />
                  <col />
                  <col width="80px" />
                </colgroup>
                <thead>
                  <tr class="tbg">
                    <th scope="col">번호</th>
                    <th scope="col">체험자명</th>
                    <th scope="col">학년</th>
                    <th scope="col">생년월일</th>
                    <th scope="col">복지할인</th>
                    <th scope="col">삭제</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(exper, i) in experList" :key="exper.incluId">
                    <td>{{ i + 1 }}</td>
                    <td>{{ exper.incluNm }}</td>
                    <td>{{ exper.gradeNm }}</td>
                    <td>{{ exper.incluBirthMonDate }}</td>
                    <td>{{ exper.pesnDivNm }}</td>
                    <td><button @click="() => onDeleteExper(exper)">삭제</button></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </template>
        </template>

        <template v-if="leaderInfoList.length > 0">
          <h5 class="stitle2 mb10">인솔자목록</h5>
          <div class="tb_wrap mb30">
            <table class="tb_basic">
              <caption>인솔자목록 리스트</caption>
              <colgroup>
                <col width="10%" />
                <col width="20%" />
                <col />
                <col />
                <col width="20%" />
                <col width="80px" />
              </colgroup>
              <thead>
                <tr class="tbg">
                  <th scope="col">번호</th>
                  <th scope="col">인솔자명</th>
                  <th scope="col">휴대폰</th>
                  <th scope="col">E-mail</th>
                  <th scope="col">복지할인</th>
                  <th scope="col">삭제</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(leader, i) in leaderList" :key="leader.leaderId">
                  <td>{{ i + 1 }}</td>
                  <td>{{ leader.leaderNm }}</td>
                  <td>{{ leader.phoneNo }}</td>
                  <td>{{ leader.email }}</td>
                  <td>{{ leader.pesnDivNm }}</td>
                  <td><button @click="() => onDeleteLeader(leader)">삭제</button></td>
                </tr>
              </tbody>
            </table>
          </div>
        </template>
      </template>
      <div class="btn_wrap">
        <a class="btn btn_bg color" @click="onConfirm">저장</a>
        <a class="btn btn_bg gray" @click="closeModal">취소</a>
      </div>
      <template slot="footer"></template>
      <!-- /footer -->
    </modal>
  </div>
</template>

<script>
import { isEqual, cloneDeep } from 'lodash';
import { ModiValidate } from '@/api/api_reserve';
import { isLoggedIn } from '@/utils/reserve';
import { getReservationPdDetail } from '@/api/api_reserve';
import Modal from '@/components/common/Modal.vue';
import TabItem from '@/components/common/TabItem.vue';
import PrivateAgreePopup from '@/components/popup/PrivateAgreePopup.vue';
import CountButton from '@/components/common/CountButton.vue';

export default {
  components: { Modal, TabItem, PrivateAgreePopup, CountButton },
  props: {
    pdRvNo: {
      type: String,
      default: '',
    },
    mrktnPdYn: {
      type: String,
      default: '',
    },
    couponsaleSeq: {
      type: [String, Number],
      default: 0,
    },
    confirmChange: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      modal: {
        open: false,
      },
      rvDetail: {},
      scheSeqNoList: [],
      rvPesn20List: [],
      rvPesn10List: [],
      experInfoList: [],
      leaderInfoList: [],
      experList: [],
      leaderList: [],
      orgBooking: null,
    };
  },
  computed: {
    rvPesn20Pcnt() {
      return this.rvPesn20List.reduce((acc, cur) => acc + cur.pcnt, 0);
    },
    editAble() {
      return this.rvDetail.rvProgSitu !== '05';
    },
    editExhpAble() {
      const rvProgSitu = this.rvDetail.rvProgSitu;
      return rvProgSitu === '03' || rvProgSitu === '10' || rvProgSitu === '02';
    },
  },
  watch: {
    'modal.open': function (to) {
      if (to) {
        this.loadDetailData();
      }
    },
  },
  methods: {
    openModal() {
      this.modal.open = true;
    },
    closeModal() {
      this.modal.open = false;
    },

    makeBooking() {
      let includeList;
      if (this.rvDetail.groupPersDiv === '01') {
        includeList = this.rvPesn20List.map((e) => {
          return {
            pcnt: e.pcnt,
            pdNo: e.pdNo,
            mrktnScheSeqNo: this.rvDetail.scheSeqNo,
            scheSeqNo: this.rvDetail.scheSeqNo,
            reciDivCd: '20',
            pesnDivCd: e.pesnDivCd,
            pdRvNo: this.rvDetail.pdRvNo,
          };
        });
      } else {
        includeList = this.experList.map((item) => {
          return {
            ...item,
            scheSeqNo: this.rvDetail.scheSeqNo,
          };
        });
      }

      const scheSeqObj = this.scheSeqNoList.find((e) => e.mrktnScheSeqNo === this.rvDetail.scheSeqNo);

      return {
        pdRvNo: this.pdRvNo,
        scheSeqNo: this.rvDetail.scheSeqNo,
        mrktnScheSeqNo: this.rvDetail.scheSeqNo,
        scheTm: scheSeqObj?.tm || this.rvDetail.tm,
        expVisitRvdt: this.rvDetail.expVisitRvdtF,
        includeList: includeList,
        leaderList: this.leaderList.map((item) => {
          return {
            ...item,
            scheSeqNo: this.rvDetail.scheSeqNo,
          };
        }),
        experPcnt: includeList.reduce((acc, cur) => acc + cur.pcnt, 0),
        leaderPcnt: this.leaderList.length,
        rvAmt: this.rvDetail.rvAmt,
        dcAmt: this.rvDetail.dcAmt,
      };
    },
    openDetailModal() {
      if (this.mrktnPdYn === 'Y') {
        alert('마케팅 상품은 변경 하실 수 없습니다.');
        return false;
      }
      if (this.couponsaleSeq > 0) {
        alert('쿠폰이 적용된 상품은 변경 하실 수 없습니다. 취소 후 다시 예약해 주세요.');
        return false;
      }
      if (isLoggedIn()) {
        this.openModal();
      }
    },
    onDeleteExper(exper) {
      if (this.experList.length <= 1) {
        alert('체험인원은 1명 이상이어야 합니다.');
        return false;
      } else {
        this.experList = this.experList.filter((e) => e !== exper);
      }
    },
    onDeleteLeader(leader) {
      if (this.leaderList.length <= 1) {
        alert('인솔자는 1명 이상이어야 합니다.');
        return false;
      } else {
        this.leaderList = this.leaderList.filter((e) => e !== leader);
      }
    },
    onChangeExperPcnt(rvPesn, pcnt) {
      rvPesn.pcnt = pcnt;
    },
    onAddLeader() {
      const firstPesn = this.rvPesn10List[0];
      this.leaderList.push({
        isAdded: true,
        pdNo: firstPesn?.pesnDivCd.pdNo || this.rvDetail.pdNo,
        reciDivCd: '10',
        leaderNm: '',
        phoneNo: '',
        email: '',
        pesnDivCd: firstPesn?.pesnDivCd || '01',
      });
    },
    async onConfirm() {
      const changedBooking = this.makeBooking();

      //변경이 없으면 이전 변경 내용 초기화
      if (isEqual(this.orgBooking, changedBooking)) {
        this.confirmChange({ pdRvNo: this.pdRvNo, clear: true });
      } else {
        //단체 예약이면
        if (this.rvDetail.groupPersDiv === '01') {
          if (changedBooking.experPcnt < 15) {
            alert('단체예약 체험인원은 15명 이상이어야 합니다.');
            return false;
          }
        }

        if (this.leaderList.length > 0) {
          let pesnDivCd07Cnt = 0;

          const checkLeader = this.leaderList.every((leader) => {
            if (!leader.leaderNm) {
              alert('인솔자/보호자 이름은 필수 값 입니다.');
              return false;
            }
            if (!leader.phoneNo) {
              alert('인솔자/보호자 전화번호는 필수 값 입니다.');
              return false;
            }
            if (!leader.email) {
              alert('인솔자/보호자 이메일은 필수 값 입니다.');
              return false;
            }

            if (!leader.pesnDivCd) {
              alert('인솔자/보호자 복지할인은 필수 값 입니다.');
              return false;
            }

            if (leader.pesnDivCd === '07') {
              pesnDivCd07Cnt++;
            }
            return true;
          });

          if (pesnDivCd07Cnt > 0 && changedBooking.experPcnt / pesnDivCd07Cnt < 15) {
            alert('단체인솔자 할인은 인솔자 1인당 체험자가 15명 이상이여야 합니다.');
            return false;
          }

          if (!checkLeader) {
            return false;
          }
        }

        const validInfo = await ModiValidate({ bookingList: [changedBooking] });
        if (validInfo.success) {
          if (validInfo.response?.capa?.okYn !== 'Y') {
            alert('해당 회차 예약 가능한 인원이 부족합니다.');
            return false;
          }
        }

        this.confirmChange(changedBooking);
      }

      this.closeModal();
    },
    loadDetailData() {
      getReservationPdDetail(this.pdRvNo, 'modify').then((data) => {
        if (data.success) {
          const { rvDetail, scheSeqNoList, experList } = data.response;
          const { pesnInfoList = [], rvPesnList = [] } = data.response;

          const leaderInfoList = [];
          const experInfoList = [];
          pesnInfoList.forEach((e) => {
            if (e.reciDivCd === '20') {
              experInfoList.push(e);
            } else if (e.reciDivCd === '10') {
              leaderInfoList.push(e);
            }
          });
          this.rvPesn20List = rvPesnList.filter((e) => e.reciDivCd === '20');
          this.rvPesn10List = rvPesnList.filter((e) => e.reciDivCd === '10');

          this.rvDetail = rvDetail;
          this.scheSeqNoList = scheSeqNoList;
          this.leaderInfoList = leaderInfoList;
          this.experInfoList = experInfoList;
          this.leaderList = data.response.leaderList;
          this.experList = experList;

          this.orgBooking = this.makeBooking();
        }
      });
    },
  },
  created() {
    //this.openModal();
  },
};
</script>

<style lang="scss" scoped>
::v-deep .pop_layer {
  min-width: 1024px;
  left: calc(50% - 500px);
  margin-left: 0;
}

@media all and (max-width: 1024px) {
  ::v-deep .pop_layer {
    min-width: 100%;
    left: 0;
  }
}

.popup_wrap {
  display: inline-block;
  & a {
    cursor: pointer;
  }
  & .checkbox input[type='checkbox'] + label {
    font-size: 16px;
    display: inline-block;
    height: 19px;
    padding-left: 23px;
    line-height: 19px;
    background-size: 19px 19px;
    width: initial;
  }

  & .tb_basic {
    & .editable {
      & td {
        padding: 2px;
        & select {
          width: 100%;
        }
        & input {
          width: 100%;
          // height: 23px;
          // line-height: 21px;
          // padding: 0 5px;
        }
      }
    }
  }
}
.exhp-edit-box {
  position: sticky;
  top: 0;
  // background: linear-gradient(to bottom, rgba(255, 255, 255, 1) 80%, rgba(255, 255, 255, 0.9) 100%);
  background: #fff;
  box-shadow: 0 4px 4px -4px black;
  padding-bottom: 5px;

  & .private-box {
    position: absolute;
    top: 0;
    right: 110px;
  }
}
.road-tabs {
  display: flex;
  & .tabs {
    display: flex;
    flex-direction: column;
    width: 180px;
    flex-shrink: 0;
  }

  .contents {
    overflow: hidden;
    position: relative;
    flex: 1;
  }

  .item {
    box-sizing: border-box;
    padding: 0 10px;
    width: 100%;
    min-height: 100%;
    transition: all 0.8s ease;
  }

  & .hall-list {
    display: grid;
    grid-template-columns: auto auto auto;

    & > div {
      display: flex;
      justify-content: space-between;
      flex-shrink: 0;
      padding: 2px 5px;
      font-size: 13px;
      cursor: default;
      &:hover {
        background: #fafafa;
      }
    }
  }
}

/* 트랜지션 전용 스타일 */
.v-leave-active {
  position: absolute;
}
.v-enter {
  transform: translateY(100%);
}
.v-leave-to {
  transform: translateY(-100%);
}
</style>
